import React, { useState } from 'react';
import { Paper, Tab, Tabs } from '@material-ui/core';

import { CreateSpecialOrder } from 'components/marketing/components/createSpecialOrder';
import { TabPanel } from 'shared';
import { SpecialOrders } from 'shared/components/specialOrders/specialOrders';

function SpecialOrdersMarketing() {
    const [selectedTab, setSelectedTab] = useState('0');
    const handleChange = (event, value) => {
        setSelectedTab(value);
    };

    return (
        <Paper>
            <Tabs onChange={handleChange} value={selectedTab} indicatorColor="primary" textColor="primary" centered>
                <Tab id="ViewSpecialOrders_Tab" label="View Special Orders" value="0" />
                <Tab id="CreateSpecialOrder_Tab" label="Create Special Order" value="1" />
            </Tabs>
            <TabPanel selectedTab={selectedTab} index="0">
                <SpecialOrders editable />
            </TabPanel>
            <TabPanel selectedTab={selectedTab} index="1">
                <CreateSpecialOrder />
            </TabPanel>
        </Paper>
    );
}

export { SpecialOrdersMarketing };
